<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top>
      {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn></v-snackbar
    >
    <ClientNav />
    <v-row dense>
      <v-col cols="12" lg="3" xl="2">
        <ClientSide />
      </v-col>
      <v-col cols="12" lg="9" xl="10">
        <v-card class="pa-2" outlined tile height="100%">
          <v-data-table
            :headers="headers"
            :items="documents"
            :loading="isLoading"
            loading-text="Document Library images"
            :search="search"
            height="550"
            item-class="class-A"
            class="document-library-table"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Document Library</v-toolbar-title>
                <v-divider class="mx-4 d-none d-sm-flex" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  clearable
                  flat
                  solo-inverted
                  hide-details
                  prepend-inner-icon="search"
                  label="search"
                  class="desktop"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-btn
                  class="mb-2 mr-4 white--text"
                  @click="filterDialog = true"
                  color="#2b6993"
                >
                  <v-icon left>filter_list</v-icon>
                  Filter</v-btn>
                
                <v-btn
                  class="mb-2 mr-4 white--text d-none d-sm-flex"
                  @click="downloadAllDocuments"
                  color="#2b6993"
                > 
                  <v-icon left>mdi-download</v-icon>
                  Download All
                </v-btn>
                <v-dialog
                  v-model="dialog"
                  :fullscreen="isMobile"
                  :hide-overlay="isMobile"
                  transition="dialog-bottom-transition"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-if="!isAuditorRole"
                      color="#2b3990"
                      dark
                      class="mb-2"
                      v-on="on"
                      @click="showAdd()"
                    >
                      <v-icon left>add</v-icon>
                      Add Document</v-btn
                    >
                  </template>
                  <v-card>
                    <v-toolbar v-if="isMobile" dark color="primary">
                      <v-btn icon dark @click="close">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-toolbar-title>{{ titleForm }}</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-toolbar-items>
                        <v-btn
                          class="white--text"
                          @click="saveFile()"
                          v-if="newDocument"
                          dark
                          text
                          >Save</v-btn
                        >
                        <v-btn
                          class="white--text"
                          @click="updateDocument()"
                          v-if="editDocument"
                          dark
                          text
                          >Update</v-btn
                        >
                      </v-toolbar-items>
                    </v-toolbar>

                    <v-toolbar v-else dark color="primary">
                      <v-toolbar-title>{{ titleForm }}</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-toolbar-items>
                        <v-btn icon dark @click="close">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-toolbar-items>
                    </v-toolbar>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="12">
                            <v-select
                              :items="categories"
                              v-model="newCategory"
                              label="Select a Category"
                            ></v-select>
                          </v-col>

                          <!-- <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="newName"
                        label="Document Name"
                      ></v-text-field>
                    </v-col> -->

                          <v-col cols="12" sm="12">
                            <form enctype="multipart/form-data">
                              <v-file-input
                                ref="fileupload"
                                chips
                                show-size
                                class="pa-2"
                                label="Document"
                                :placeholder="newImage"
                                accept="image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                @change="fileSelected"
                              ></v-file-input>
                              <template>
                                <v-card
                                  class="pa-3 mb-2"
                                  v-show="newDocumentImage"
                                >
                                  <v-img
                                    :src="newDocumentImage"
                                    height="300"
                                    contain
                                  ></v-img>
                                </v-card>
                              </template>
                            </form>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions v-if="!isMobile">
                      <v-spacer></v-spacer>
                      <v-btn
                        color="#259647"
                        class="white--text"
                        @click="saveFile()"
                        v-if="newDocument"
                        >Save</v-btn
                      >
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="updateDocument()"
                        v-if="editDocument"
                        >Update</v-btn
                      >
                      <v-btn color="blue darken-1" text @click="close"
                        >Cancel</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog
                  v-model="viewDialog"
                  :fullscreen="isMobile"
                  :hide-overlay="isMobile"
                  transition="dialog-bottom-transition"
                >
                  <v-card>
                    <v-toolbar v-if="isMobile" dark color="primary">
                      <v-btn icon dark @click="close">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-toolbar-title>{{ titleForm }} </v-toolbar-title>
                    </v-toolbar>

                    <v-toolbar v-else dark color="primary">
                      <v-toolbar-title>{{ titleForm }}</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-toolbar-items>
                        <v-btn icon dark @click="close">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-toolbar-items>
                    </v-toolbar>

                    <v-card-text>
                      <v-container>
                        <template v-if="documentImg.length > 0">
                          <div v-for="(item, i) in documentImg" :key="i">
                            <v-carousel v-if="item.ext != 'pdf'">
                              <v-carousel-item>
                                <v-row class="flex-nowrap" style="height: 100%">
                                  <v-img :src="item.aws"></v-img>
                                </v-row>
                              </v-carousel-item>
                            </v-carousel>
                            <div v-if="item.ext == 'pdf'">
                              <LoadPDF
                                :pdfFile="item.aws"
                                :pdfName="item.name"
                              />
                            </div>
                          </div>
                        </template>
                      </v-container>
                    </v-card-text>

                    <v-card-actions v-if="!isMobile">
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="close"
                        >Close</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-dialog
                  v-model="filterDialog"
                  :fullscreen="isMobile"
                  :hide-overlay="isMobile"
                  transition="dialog-bottom-transition"
                >
                  <v-card>
                    <v-toolbar v-if="isMobile" dark color="primary">
                      <v-btn icon dark @click="filterDialog = false">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-toolbar-title>Document Library Search</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-toolbar-items>
                        <v-btn
                          class="white--text"
                          @click="filterDocuments()"
                          dark
                          text
                          >Search</v-btn
                        >
                      </v-toolbar-items>
                    </v-toolbar>

                    <v-toolbar v-else dark color="primary">
                      <v-toolbar-title>Document Library Search</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-toolbar-items>
                        <v-btn icon dark @click="filterDialog = false">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-toolbar-items>
                    </v-toolbar>

                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="4">
                          <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="startDate"
                                label="Start Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                clearable
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="startDate"
                              no-title
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="menu = false">
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menu.save(date)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="12" md="4">
                          <v-menu
                            ref="menu2"
                            v-model="menu2"
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="endDate"
                                label="End Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                clearable
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="endDate"
                              no-title
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="menu2 = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menu2.save(date)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-select
                            :items="categories"
                            v-model="category"
                            label="Category"
                            clearable
                          ></v-select>
                          <v-expand-transition>
                            <v-text-field
                              v-if="category === 'Others'"
                              label="Enter Specific Category"
                              v-model="others"
                            />
                          </v-expand-transition>
                        </v-col>
                      </v-row>
                    </v-container>
                    <v-card-actions v-if="!isMobile" cols="12" sm="12" md="3">
                      <v-spacer></v-spacer>
                      <v-btn
                        color="#259647"
                        class="white--text ml-6"
                        @click="filterDocuments()"
                        >Search</v-btn
                      >
                      <v-btn
                        color="primary"
                        class="ml-6"
                        text
                        @click="filterDialog = false"
                        >Cancel</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
              <v-text-field
                v-model="search"
                clearable
                flat
                solo-inverted
                hide-details
                prepend-inner-icon="search"
                label="search"
                class="mobile ml-5 mr-5 mb-3 mt-3"
              ></v-text-field>
            </template>
            <template v-slot:item.Category="{ item }">
              <v-select
                :items="categories"
                item-text="Name"
                item-value="id"
                label="Category"
                v-model="editedItem.Category"
                v-if="item.id === editedItem.id"
              />
              <span v-else>
                {{ item.Category }}
              </span>
            </template>
            <template v-slot:item.Name="{ item }">
              <v-text-field
                label="Name"
                v-model="editedItem.Name"
                v-if="item.id === editedItem.id"
                clearable
                @change="checkExtension(editedItem)"
              >
              </v-text-field>
              <span v-else>
                {{ item.Name }}
              </span>
            </template>
            <!--
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="downloadDocument(item)">
              mdi-download
        </v-icon>
        <v-icon small class="mr-2" @click="viewDocument(item)">
            mdi-eye
        </v-icon>
        <v-icon small @click="deleteDocument(item)">
          mdi-delete
        </v-icon>
      </template>
      -->
            <template v-slot:item.actions="{ item }">
              <div v-if="item.id === editedItem.id">
                <v-icon color="red" class="mr-2 mt-2" @click="closeItem">
                  mdi-window-close
                </v-icon>
                <v-icon color="green" class="mr-2 mt-2" @click="saveItem">
                  mdi-content-save
                </v-icon>
              </div>
              <div v-else>
                <v-icon
                  v-if="!isAuditorRole"
                  small
                  color="green"
                  class="mr-2"
                  @click="editItem(item)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon small class="mr-2" @click="downloadDocument(item)">
                  mdi-download
                </v-icon>
                <v-icon small class="mr-2" @click="viewDocument(item)">
                  mdi-eye
                </v-icon>
                <v-icon v-if="!isAuditorRole" small @click="deleteDocument(item)">
                  mdi-delete
                </v-icon>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <Foot />
  </div>
</template>

<script>
import axios from "axios";
import ClientNav from "../../components/ClientNav";
import ClientSide from "../../components/ClientSide";
import Foot from "../../components/Footer";
import moment from "moment";
//import { PDFDocument } from "pdf-lib";
import renameFileHelper from "../../mixins/renameFileHelper";
import LoadPDF from "../../components/LoadPDF.vue";

const url = require("../../client_config/config").url;

export default {
  mixins: [renameFileHelper],
  components: {
    ClientNav,
    ClientSide,
    Foot,
    LoadPDF,
  },
  data: function () {
    return {
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "Name",
        },
        { text: "Category", value: "Category" },
        { text: "Date Created", value: "CreatedDate" },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          class: "table-action",
        },
      ],
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      menu2: false,
      categories: [
        "Activities",
        "Archived ADL’s",
        "Archived MAR",
        "Archived Incident Reports",
        "Archived Communication Logs",
        "Archived Documents-Other",
        "Behavior",
        "Budget",
        "Car Accident",
        "Client Annual Documents",
        "Consents",
        "Court Documents",
        "Dept Workforce Services",
        "Education",
        "Employment",
        "Finance",
        "Fire Drill",
        "Food Stamps",
        "Guardianship Papers",
        "Host Home",
        "Housing",
        "Human Rights",
        "Insurance",
        "Intake",
        "Inventory",
        "Legal",
        "Mail",
        "Medical Visits",
        "Medical Documents",
        "Medicare/Medicaid",
        "Menus",
        "Monthly Summaries",
        "Monthly Reporting",
        "My Case",
        "PCSP",
        "Personal Documents",
        "Photos",
        "Provider Reports",
        "Psych Evaluations",
        "Psychotropic Med Plan",
        "Receipts",
        "School",
        "School Behavior Intervention Plan",
        "School IEP",
        "School Psychoeducational Evaluation",
        "Site Inspections",
        "Social Security",
        "Social Security Food Stamps Medicaid",
        "Taxes",
        "Transportation",
        "Voc Rehab",
        "Others",
      ],
      documents: [],
      isLoading: false,
      dialog: false,
      viewDialog: false,
      filterDialog: false,
      clientID: this.$route.params.clientID,
      msg: "",
      text: "",
      search: "",
      titleForm: "New Document",
      documentImg: [],
      newName: "",
      newCategory: "",
      newImage: "",
      newDocumentImage: "",
      newNotes: "",
      newDocument: false,
      editDocument: false,
      startDate: null,
      endDate: null,
      category: null,
      documentID: "",
      pdfDoc: "",
      isIMAGE: false,
      isPDF: false,
      editedIndex: -1,
      editedItem: {
        id: 0,
        Name: "",
        Category: "",
      },
      defaultItem: {
        id: 0,
        Name: "",
        Category: "",
      },
      loadingMessage: true,
      //clientName: '',
      srcPDF: "",
      loadedRatio: 0,
      page: 1,
      numPages: 0,
      rotate: 0,
      others: "",
    };
  },

  computed: {
    clientName() {
      // `this` points to the component instance
      return this.$store.state.clients.client.Name;
    },
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    isAuditorRole() {
      return localStorage.getItem("userRole") === 'Auditor'
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.getDocuments();
  },

  methods: {
    showAdd() {
      this.newDocument = true;
      this.titleForm = "Add new document";
      this.editDocument = false;
      this.newCategory = "";
      this.$refs.fileupload.value = null;
    },

    async getDocuments() {
      this.isLoading = true;
      axios
        .get(`${url}/documents/user/${this.clientID}`)
        .then((res) => {
          (this.documents = []), (this.tempData = res.data.documents);
          let count = 1;
          for (var i = 0; i < this.tempData.length; i++) {
            var dt = new Date(this.tempData[i].CreatedDate);
            this.tempData[i].CreatedDate =
              moment(dt).format("MM-DD-YYYY HH:mm");
            this.tempData[i].id = count++;
            this.documents.push(this.tempData[i]);
          }
        })
        .finally(() => (this.isLoading = false));
    },

    viewDocument(item) {
      this.editDocument = true;
      this.titleForm = "Viewing " + item.Name;
      this.viewDialog = true;
      this.documentImg = [];
      const uploadedDocuments = [];
      let fileExt = item.AWSLink.split(".").pop();
      uploadedDocuments.push({
        name: item.Name,
        id: item._id,
        aws: item.AWSLink,
        ext: fileExt,
      });

      this.documentImg = uploadedDocuments;
    },

    downloadDocument(item) {
      if (item.AWSLink === undefined) {
        this.msg = true;
        this.text = "No document found";
      } else {
        let docURL = item.AWSLink;
        var FileSaver = require("file-saver");
        FileSaver.saveAs(docURL, item.Name);
      }
    },

    close() {
      this.dialog = false;
      this.viewDialog = false;
      this.documentImg = [];
    },

    async fileSelected(e) {
      this.uploadFile = await this.renameFileHelper(
        e,
        this.clientName,
        this.newCategory
      );
    },
    saveFile() {
      const formData = new FormData();
      formData.append("document", this.uploadFile);
      var ct = { headers: { "content-type": "multipart/form-data" } };
      this.newCategory = encodeURIComponent(this.newCategory);

      axios
        .post(
          `${url}/documents/fileuploader/client/${this.clientID}/${this.newCategory}`,
          formData,
          ct
        )
        .then((res) => {
          if (res.status == 200) {
            this.dialog = false;
            this.msg = true;
            this.text = "Document added successfully";
            this.getDocuments();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    filterDocuments() {
      try {
        this.filterDialog = false;
        let category = this.category === "Others" ? this.others : this.category;
        let queryParams = {
          "CreatedDate[gte]": this.startDate,
          "CreatedDate[lte]": this.endDate,
          Category: category,
          UserID: this.clientID,
        };
        axios
          .get(`${url}/documents/query`, {
            params: queryParams,
          })
          .then((res) => {
            this.documents = [];
            for (var i = 0; i < res.data.documents.length; i++) {
              var dt = new Date(res.data.documents[i].CreatedDate);
              res.data.documents[i].CreatedDate =
                moment(dt).format("MM-DD-YYYY HH:mm");
              this.documents.push(res.data.documents[i]);
            }
          });
        this.startDate = "";
        this.endDate = "";
        this.category = "";
      } catch (error) {
        console.log(error);
      }
    },

    deleteDocument(item) {
      const id = item._id;
      confirm("Are you sure you want to delete this document?") &&
        this.documentDelete(id);
    },

    documentDelete(id) {
      axios.delete(`${url}/documents/${id}`).then((response) => {
        this.getDocuments();
        if (response.status == 400) {
          response.json().then(function (data) {
            return data.msg;
          });
        }
        this.msg = true;
        this.text = "The document has been deleted successfully.";
      });
    },

    /*
    async loadPdf(url) {
      this.loadingMessage = true;
      this.srcPDF = await pdf.createLoadingTask(url);
      this.srcPDF.promise.then(pdf => {
        this.numPages = pdf.numPages;
        this.loadingMessage = false;
      });
       
    },
  */

    editItem(item) {
      this.editedIndex = this.documents.indexOf(item);
      this.editedItem = Object.assign({ OriginalName: item.Name }, item);
    },

    deleteItem(item) {
      let index = this.documents.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.shifts.splice(index, 1);
    },

    closeItem() {
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    saveItem() {
      console.log(this.editedItem);
      if (this.editedIndex > -1) {
        var req_body = {
          Category: this.editedItem.Category,
          Name: this.editedItem.Name,
        };
        axios
          .put(`${url}/documents/${this.editedItem._id}`, req_body)
          .then((response) => {
            if (response.status == 200) {
              this.msg = true;
              this.text = response.data.msg;
              this.closeItem();
              this.getDocuments();
            } else {
              this.msg = true;
              this.text = response.data.msg;
            }
          });
      }
    },

    checkExtension(data) {
      let originalExt = data.OriginalName.split(".").pop();
      let fileExt = data.Name.split(".").pop();
      if (originalExt !== fileExt) {
        this.editedItem.Name = data.Name + "." + originalExt;
      }
    },

    updateTask() {
      var req_body = {
        UserId: this.newAssigned,
        Title: this.newTitle,
        Description: this.newDescription,
        DueDate: this.dueDate,
        Status: this.newStatus,
        UrlNotification: this.$router.history.current.path,
      };

      axios.put(`${url}/tasks/${this.taskID}`, req_body).then((response) => {
        this.getTasks();
        if (response.status == 400) {
          response.json().then(function (data) {
            alert(data.msg);
          });
        }
        this.newTitle = "";
        this.newDescription = "";
        this.newAssigned = "";
        this.dueDate = "";
        this.msg = true;
        this.text = "The task has been updated successfully.";
      });
      this.close();
    },
    async downloadAllDocuments(){
      const api_url = url;
      try {
        const response = await axios.get(`${api_url}/documents/downloadAll/${this.clientID}`, {
          responseType: "blob", // Important for handling binary data
        });

        // Create a blob from the response
        const blob = new Blob([response.data], { type: "application/zip" });
        const url = window.URL.createObjectURL(blob);

        // Create a download link and trigger the download
        const a = document.createElement("a");
        a.href = url;
        a.download = "files.zip";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } catch (error) {
        console.error(error);
      }
    }
  },
};
</script>
<style>
@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

.document-library-table table > tbody > tr > td:last-child {
  display: inline-flex;
}

#loadingMessage {
  width: 96%;
  height: 80%;
  z-index: 1000;
  background: transparent;
  top: 70px;
  left: 35px;
  position: absolute;
}

#loadingMessage > div {
  left: 50%;
  top: 50%;
}
</style>
